module.exports = new __parcel__URL__("60508_h.32166289.jpg").toString();